import axios from 'axios';

// admin 모듈 API 주소. 배포 환경에 맞게 REACT_APP_API_BASE_URL 로 덮어쓸 수 있다.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:9082';

const client = axios.create({
  baseURL: API_BASE_URL,
});

client.interceptors.request.use((config) => {
  const saved = localStorage.getItem('onetak_admin_auth');
  if (saved) {
    const { accessToken } = JSON.parse(saved);
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
  }
  return config;
});

// 여러 API가 동시에 401을 받아도(예: 대시보드의 병렬 조회) 알럿이 중복으로 뜨지 않도록 가드한다.
let sessionExpiredHandled = false;

client.interceptors.response.use(
  (response) => {
    // 슬라이딩 세션: 서버가 재발급한 토큰을 응답 헤더로 내려주면 저장된 accessToken 을 교체한다.
    // 이후 요청 인터셉터가 최신 토큰을 실어보내므로, 사용이 있는 한 세션이 계속 연장된다.
    const refreshed = response.headers['x-refresh-token'];
    if (refreshed) {
      try {
        const saved = JSON.parse(localStorage.getItem('onetak_admin_auth') || '{}');
        if (saved && saved.accessToken) {
          saved.accessToken = refreshed;
          localStorage.setItem('onetak_admin_auth', JSON.stringify(saved));
        }
      } catch { /* 저장 실패는 무시(다음 요청에서 다시 재발급됨) */ }
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // 토큰 만료/무효 - 안내 후 로그인 화면으로 돌려보낸다.
      localStorage.removeItem('onetak_admin_auth');

      if (window.location.pathname !== '/login' && !sessionExpiredHandled) {
        sessionExpiredHandled = true;
        window.alert('로그인이 만료되었습니다. 다시 로그인해주세요.');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default client;
